module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 111
// module chunks = 0 1 2